interface HeroSectionProps {
  onApplyClick: () => void;
}

export default function HeroSection({ onApplyClick }: HeroSectionProps) {
  return (
    <section className="relative h-screen min-h-[700px] w-full overflow-hidden">
      {/* Background Image — Editorial Wedding Collage */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/edited_65a44b1d16edf3cfab075688a0491042_62b13356.jpg"
          alt="Fundo editorial com elementos de casamento em tons verde oliva e creme"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Olive Overlay — subtle to keep the photo visible but ensure text readability */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-olive/20 to-black/50"></div>
      <div className="absolute inset-0" style={{ backgroundColor: 'oklch(var(--primary-900) / 0.25)' }}></div>

      {/* Content */}
      <div className="relative z-10 h-full w-full flex flex-col items-center justify-center text-center px-6">
        <div className="max-w-3xl mx-auto">
          <p className="animate-fade-in animate-delay-200 text-xs md:text-sm tracking-[0.25em] uppercase mb-8 md:mb-10 font-light" style={{ color: 'oklch(var(--accent-300))' }}>
            A primeira imersão para noivas que querem escolher com intenção
          </p>

          <h1 className="animate-fade-in animate-delay-400 font-heading text-4xl md:text-6xl lg:text-7xl leading-[1.05] md:leading-[1.04] mb-6 md:mb-8 tracking-tight" style={{ color: 'oklch(var(--background-50))' }}>
            THE FUTURE
            <br />
            WEDDING
          </h1>

          <p className="animate-fade-in animate-delay-600 text-sm md:text-base leading-relaxed max-w-2xl mx-auto mb-10 md:mb-12 font-light" style={{ color: 'oklch(var(--background-50) / 0.85)' }}>
            Uma imersão para noivas que desejam planejar com clareza, intenção e significado.
            <br className="hidden md:block" />
            Você não precisa de mais referências. Você precisa das respostas certas, das conexões certas
            e da confiança para tomar decisões que realmente façam sentido para a sua história.
          </p>

          <div className="animate-fade-in animate-delay-800">
            <button
              onClick={onApplyClick}
              className="group px-6 py-3 md:px-10 md:py-4 text-xs md:text-sm tracking-[0.2em] uppercase rounded-md transition-all duration-500 whitespace-nowrap cursor-pointer font-semibold relative overflow-hidden"
              style={{
                backgroundColor: '#ADC178',
                color: '#FFFFFF',
              }}
            >
              <span className="relative z-10">Quero Garantir Minha Vaga</span>
              <div
                className="absolute inset-0 transition-transform duration-500 -translate-x-full group-hover:translate-x-0"
                style={{ backgroundColor: '#9AAF65' }}
              ></div>
            </button>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-fade-in animate-delay-800">
          <span className="text-[10px] tracking-[0.3em] uppercase" style={{ color: 'oklch(var(--background-50) / 0.5)' }}>
            Role para descobrir
          </span>
          <div className="w-5 h-8 rounded-full flex items-start justify-center p-1" style={{ border: '1.5px solid oklch(var(--background-50) / 0.3)' }}>
            <div className="w-1 h-2 rounded-full animate-subtlePulse" style={{ backgroundColor: 'oklch(var(--accent-400))' }}></div>
          </div>
        </div>
      </div>
    </section>
  );
}